import script from "./ConfermaOrdine.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfermaOrdine.vue?vue&type=script&setup=true&lang=js"

import "./ConfermaOrdine.vue?vue&type=style&index=0&id=3628aa97&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3628aa97"]])

export default __exports__